import apiClient from '../middleware/apiClient';
import { SESSION } from '../helpers/apis';
import { COTTON_OAUTH_VALIDATE, COTTON_V1_DISCONNECT } from '../helpers/cottonApis';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { cottonForceDisconnect, forceLogout } from '../helpers/logout';

export const GET_SESSION = 'GET_SESSION';
export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const GET_SESSION_FAILURE = 'GET_SESSION_FAILURE';

function dispatchGetSession(isCottonSession = false) {
  return {
    type: GET_SESSION,
    payload: apiClient.fetch(isCottonSession ? COTTON_OAUTH_VALIDATE : SESSION),
  };
}

function dispatchGetSessionSuccess(payload) {
  return {
    type: GET_SESSION_SUCCESS,
    payload,
  };
}

function dispatchGetSessionFailure(error) {
  return {
    type: GET_SESSION_FAILURE,
    payload: error,
  };
}

export const getSession = (isCottonSession = false) => async (dispatch, getState) => {
  const { auth: { crsId } = {} } = getState();

  if (crsId) {
    return { status: 'CONSENT' };
  }
  try {
    const response = await dispatch(dispatchGetSession(isCottonSession)).payload;
    // Cotton's oauth/validate returns the status at the top level, while the Ruby
    // session API nests it under `session`. Normalize to the nested shape.
    const normalized = isCottonSession ? { session: response } : response;
    const { session = {} } = normalized;
    const { auth = {} } = getState();
    if (auth.status && auth.status !== session.status) {
      // If the auth status has changed during the session, then reload the app.
      window.location.reload();
    }
    dispatch(dispatchGetSessionSuccess(normalized));
    return session;
  } catch (error) {
    dispatch(dispatchGetSessionFailure(error));
    throw error;
  }
};
export const disconnectCottonSession = async () => {
  await apiClient.fetch(COTTON_V1_DISCONNECT);
};

export const disconnectSessions = async () => {
  const { disableRubyApisPCI, isCottonEnabled } = cottonFlagManager;
  if (isCottonEnabled && disableRubyApisPCI) {
    cottonForceDisconnect();
    return;
  }
  if (isCottonEnabled) {
    await disconnectCottonSession();
  }
  forceLogout();
};
